var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMt = function SvgMt(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21786_20543",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "rotate(-90 10 10)",
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21786_20543)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "rotate(-90 10 10)",
    fill: "#D2282D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42188 6.57687C4.42188 6.84687 4.82687 7.04937 5.02937 7.11687H6.44687C6.77087 7.11687 6.89687 6.75687 6.91937 6.57687V5.02437C6.91937 4.70037 6.60437 4.52937 6.44687 4.48438H4.89437C4.57037 4.48438 4.44437 4.84437 4.42188 5.02437V6.57687Z",
    fill: "#787774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.6775H4.33099C4.36861 6.81554 4.479 6.92548 4.58618 7.00408C4.69664 7.08508 4.82327 7.1474 4.925 7.18744V8.4675V8.5675H5.025H6.4425H6.5425V8.4675V7.20776C6.69462 7.17717 6.8031 7.07861 6.87508 6.97037C6.93833 6.87526 6.97726 6.76792 6.99835 6.6775H8.4H8.5V6.5775V5.025V4.925H8.4H7.00641C6.98029 4.77606 6.89791 4.66019 6.80483 4.57615C6.7203 4.49983 6.62383 4.44655 6.5425 4.41392V3V2.9H6.4425H4.89H4.79V3V4.39474C4.63788 4.42533 4.5294 4.52389 4.45742 4.63213C4.39417 4.72723 4.35524 4.83458 4.33415 4.925H3H2.9V5.025V6.5775V6.6775H3Z",
    stroke: "#D2282D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5175 6.5775V6.4775H4.4175H3.1V5.125H4.4175H4.50578L4.51673 5.0374C4.52657 4.95866 4.55975 4.83943 4.62396 4.74287C4.68672 4.64849 4.77171 4.585 4.89 4.585H4.99V4.485V3.1H6.3425V4.485V4.56043L6.41503 4.58115C6.48163 4.60018 6.5855 4.64759 6.6708 4.7246C6.75471 4.80035 6.815 4.89897 6.815 5.025V5.125H6.915H8.3V6.4775H6.915H6.82672L6.81577 6.5651C6.80593 6.64384 6.77275 6.76307 6.70854 6.85963C6.64578 6.95401 6.56079 7.0175 6.4425 7.0175H6.3425V7.1175V8.3675H5.125V7.1175V7.04542L5.05662 7.02263C4.96251 6.99126 4.8206 6.92797 4.70445 6.8428C4.58323 6.7539 4.5175 6.66185 4.5175 6.5775Z",
    stroke: "#787774",
    strokeWidth: 0.2
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mt.81c3d6a28459cb6c69e46352a1baccd7.svg";